import { createAsyncThunk } from "@reduxjs/toolkit";
import { bffApi, type MarketDialogueDto } from "../../autogen/bff-api";
import { readSettled } from "../../common/redux/untilSettled";

export const fetchSettledMarketDialogue = createAsyncThunk<MarketDialogueDto, { marketDialogueId: string }>(
  "marketDialogue/fetchSettled",
  async ({ marketDialogueId }, thunk) => {
    try {
      return await readSettled(bffApi.endpoints.getMarketDialogue, { marketDialogueId }, thunk);
    } catch (e) {
      return thunk.rejectWithValue(e);
    }
  },
);
